import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { History } from "lucide-react";
import { DEFCON_COLORS } from "@/lib/defcon";

function timeAgo(iso) {
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

// Fan-facing timeline of recent Crashout DEFCON changes.
export default function DefconHistory({ className = "" }) {
  const [changes, setChanges] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/defcon/history");
        setChanges(data.changes || []);
      } catch {
        setChanges([]);
      }
    })();
  }, []);

  if (!changes || changes.length === 0) return null;

  return (
    <div className={className} data-testid="defcon-history">
      <div className="label-eyebrow text-[var(--ff-red)] mb-4 flex items-center gap-2">
        <History size={13} /> DEFCON History
      </div>
      <div className="relative pl-5">
        <div className="absolute left-[5px] top-1 bottom-1 w-px bg-[var(--ff-border)]" />
        <div className="space-y-4">
          {changes.map((c, i) => {
            const color = DEFCON_COLORS[c.level] || "#FF3B30";
            return (
              <div key={c.id || i} className="relative" data-testid={`defcon-history-row-${i}`}>
                <span
                  className="absolute -left-5 top-1 w-3 h-3 rounded-full border-2 border-[var(--ff-bg)]"
                  style={{ background: color }}
                />
                <div className="flex items-baseline gap-2 flex-wrap">
                  <span className="font-display text-lg" style={{ color }}>{c.level}</span>
                  <span className="font-mono-ui text-xs uppercase tracking-[0.12em] text-white">{c.label}</span>
                  <span className="font-mono-ui text-[0.6rem] uppercase tracking-[0.12em] text-[var(--ff-text-dim)]">· {timeAgo(c.at)}</span>
                </div>
                {c.note && <p className="text-[var(--ff-text-dim)] text-sm mt-0.5">{c.note}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
